<p>Barcode</p>
<kendo-dropdownlist #barcodeType [data]="data"
(valueChange)="onValueChange($event)"
[(ngModel)]="selectedItem"
[disabled]="disabled"
>
</kendo-dropdownlist>
